<template>
  <div>
    <Row type="flex" justify="space-between" :gutter="15">
      <i-col span="6">
        <div class="box no-border-radius ">
          <Spin v-if="loadingStatus" fix />
          <div class="box-header with-border">
            <h3 class="box-title">
              <i class="fas fa-code-branch" style="padding-right: 10px" />车库拓扑图
            </h3>
          </div>
          <div class="box-body">
            <Tree ref="tree" show-checkbox :data="topologyTreeData" style="margin-left: 15px" @on-select-change="onTreeNodeSelect" />
          </div>
        </div>
      </i-col>
      <i-col span="18">
        <div class="box no-border-radius ">
          <div class="box-header with-border">
            <h3 class="box-title">
              <i class="fas fa-bars" style="padding-right: 10px" />参数配置{{ objectName ? ': ' + objectName : '' }}
            </h3>
            <div class="box-tools pull-right" />
          </div>
          <div class="box-body">
            <ProvisioningParameter
              :object-id="objectId"
              :object-type="objectType"
              :object-name="objectName"
            />
          </div>
        </div>
      </i-col>
    </Row>
  </div>
</template>

<script>
import request from '@/utils/request'
import ProvisioningParameter from './form/parameter'
export default {
  name: 'ParkingProvision',
  components: {
    ProvisioningParameter
  },
  data() {
    return {
      topologyTreeData: [],
      loadingStatus: true,
      objectId: 0,
      objectType: -1,
      objectName: ''
    }
  },
  computed: {
  },
  mounted: function() {
    this.loadTopology()
  },
  methods: {
    getTreeNodeOptions(label, id, icon, type) {
      return {
        label: label,
        icon: icon,
        type: type,
        id: id,
        expand: true,
        children: [],
        title: label
        // render: (h, { root, node, data }) => {
        //   return h('span', {
        //     style: { cursor: 'pointer' },
        //     on: {
        //       click: () => {
        //         this.loadParameter(data)
        //       }
        //     }
        //   }, [
        //     h('i', { class: ['fas', data.icon], style: { marginRight: '5px', color: '#19be6b' }}),
        //     h('span', data.label)
        //   ])
        // }
      }
    },
    onTreeNodeSelect: function(nodes) {
      const node = nodes[nodes.length - 1]
      if (node) {
        this.objectId = node.id
        this.objectType = node.type
        this.objectName = node.label
        // request({
        //   url: this.$config.apiContextPath + '/parameter/' + node.id + '?type=' + node.type,
        //   method: 'get'
        // }).then(res => {
        //   this.loadingStatus = false
        //   this.parameterData = res.data
        //   this.objectId = node.id
        //   this.objectType = node.type
        //   this.changed = !this.changed
        // }).catch(error => {
        //   this.loadingStatus = false
        //   console.log(error)
        // })
      }
    },
    loadTopology: function() {
      this.loadingStatus = true
      request({
        url: this.$config.apiContextPath + '/topology',
        method: 'get'
      }).then(res => {
        this.loadingStatus = false
        this.topologyTreeData = this.getToplogyTreeData(res.data)
      }).catch(error => {
        this.loadingStatus = false
        console.log(error)
      })
    },
    getToplogyTreeData: function(data) {
      const that = this
      const treeData = []
      // const tree = [{ title: '系统菜单', expand: true, children: [] }]
      if (data && data.length > 0) {
        for (const item of data) {
          const parking = item.parking
          const parkingNode = this.getTreeNodeOptions(parking.name, parking.id, 'fa-warehouse', 1)
          if (item.parkingAgents && item.parkingAgents.length > 0) {
            for (const agent of item.parkingAgents) {
              parkingNode.children.push(
                this.getTreeNodeOptions(agent.label, agent.id, 'fa-tablet-alt', 5))
            }
          }
          treeData.push(parkingNode)
        }
      }
      return treeData
    }
  }
}
</script>

<style scoped>
.box-body {
  padding: 0px !important;
  height: 600px;
}
.ivu-tree-title {
  font-size: 14px !important;
}
</style>
